module.exports = __webpack_public_path__ + "img/i_icon07.350e4874.png";